<template>
  <div>
    <div class="common-box border-t0" style="height:620px;">
      <!-- 浏览 -->
      <div class="browse">
        <span class="browseTip">{{hotShow?'本月热销基金':'您浏览过的基金'}}</span>
        <ul class="browseName clearfix">
          <!-- <li v-show="!hotShow" v-for="(item,i) in hotFundLists" :key="i"><a :href="'https://www.myfund.com/mutualfund/'+item.FundCode+'.html'" target="_blank">{{item.Title}}</a></li> -->
          <li v-show="hotShow" v-for="(item,i) in hotFundLists" :key="i"><a :href="'https://www.myfund.com/mutualfund/'+item.FundCode+'.html'" target="_blank">{{item.Title}}</a></li>
        </ul>
      </div>
      <el-row class="row-one margin-t20">
        <span class="row-one-title">基金购买</span>
        <Reback class="row-one-fr" @click.native="returnClick"></Reback>
        <span class="row-one-fr" @click="detailsClick">查看资产详情</span>
      </el-row>
      <el-form class="form-single-inline margin-t20" :inline="true" :model="fundListsForm" style="position: relative;">
        <el-form-item label="基金公司：">
          <el-select v-model="fundListsForm.company">
            <el-option v-for="(item,i) in companyLists" :key="i" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="基金类型：">
          <el-select v-model="fundListsForm.type">
            <el-option label="所有类型" value=""></el-option>
            <el-option label="股票型" value="0"></el-option>
            <el-option label="债券型" value="1"></el-option>
            <el-option label="货币型" value="2"></el-option>
            <el-option label="混合型" value="3"></el-option>
            <el-option label="专户型" value="4"></el-option>
            <el-option label="指数型" value="5"></el-option>
            <el-option label="QDII" value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快速查询：">
          <el-input v-model="fundListsForm.name" placeholder="基金代码/拼音/简称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="search" @click="searchClick">查询 <i class="el-icon-search"></i></el-button>
        </el-form-item>
        <el-form-item style="position:absolute;right:-24px;">
          <el-button type="search"><a href="https://www.myfund.com/fundrank.html" target="_block" style="display:block;color:#fff;">基金排名</a></el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-radio-group v-model="fundListsForm.buy" class="radio-single-one" @change="buyChange">
            <el-radio :label="1" style="margin-left: 22px;">不限</el-radio>
            <el-radio :label="2">可购买</el-radio>
          </el-radio-group>
        </el-form-item> -->
      </el-form>
      <!-- 表格 -->
      <el-table v-loading="loading" element-loading-text="加载中..." class="table-two margin-t10" :data="fundListsTableData" :default-sort="{prop: 'date', order: 'descending'}" style="width:100%;">
        <el-table-column type="index" label="序号" width="48" fixed>
        </el-table-column>
        <el-table-column prop="fundcode" label="基金代码" width="78" fixed>
        </el-table-column>
        <el-table-column prop="fundname" label="基金名称" width="160" fixed>
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" popper-class="table-two-tip" :content="scope.row.fundname" placement="right">
              <a :href="'https://www.myfund.com/mutualfund/'+ scope.row.fundcode +'.html'" class="table-single-a" target="_blank">{{scope.row.fundname}}</a>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="fundtype1" label="基金类型" width="90" fixed>
        </el-table-column>
        <el-table-column prop="risklevel1" label="风险等级" width="78">
        </el-table-column>
        <el-table-column prop="status1" label="基金状态" width="78">
        </el-table-column>
        <!-- sortable -->
        <el-table-column prop="nav" label="单位净值" width="100">
        </el-table-column>
        <el-table-column prop="DayBenefit" label="日涨跌" width="92">
          <template slot-scope="scope">
            <span v-if="parseFloat(scope.row.DayBenefit.replace('%','')) > 0" class="rColor">{{scope.row.DayBenefit}}</span>
            <span v-else-if="parseFloat(scope.row.DayBenefit.replace('%','')) < 0" class="gColor">{{scope.row.DayBenefit}}</span>
            <span v-else>{{parseFloat(scope.row.DayBenefit.replace('%','')) =='--'?'--':scope.row.DayBenefit}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="OneWeekRedound" label="近1周" width="92">
          <template slot-scope="scope">
            <span v-if="parseFloat(scope.row.OneWeekRedound.replace('%','')) > 0" class="rColor">{{scope.row.OneWeekRedound}}</span>
            <span v-else-if="parseFloat(scope.row.OneWeekRedound.replace('%','')) < 0" class="gColor">{{scope.row.OneWeekRedound}}</span>
            <span v-else>{{parseFloat(scope.row.OneWeekRedound.replace('%','')) =='--'?'--':scope.row.OneWeekRedound}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="OneMonthRedound" label="近1月" width="92">
          <template slot-scope="scope">
            <span v-if="parseFloat(scope.row.OneMonthRedound.replace('%','')) > 0" class="rColor">{{scope.row.OneMonthRedound}}</span>
            <span v-else-if="parseFloat(scope.row.OneMonthRedound.replace('%','')) < 0" class="gColor">{{scope.row.OneMonthRedound}}</span>
            <span v-else>{{parseFloat(scope.row.OneMonthRedound.replace('%','')) =='--'?'--':scope.row.OneMonthRedound}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ThreeMonthRedound" label="近3月" width="92">
          <template slot-scope="scope">
            <span v-if="parseFloat(scope.row.ThreeMonthRedound.replace('%','')) > 0" class="rColor">{{scope.row.ThreeMonthRedound}}</span>
            <span v-else-if="parseFloat(scope.row.ThreeMonthRedound.replace('%','')) < 0" class="gColor">{{scope.row.ThreeMonthRedound}}</span>
            <span v-else>{{parseFloat(scope.row.ThreeMonthRedound.replace('%','')) =='--'?'--':scope.row.ThreeMonthRedound}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="SixMonthRedound" label="近6月" width="92">
          <template slot-scope="scope">
            <span v-if="parseFloat(scope.row.SixMonthRedound.replace('%','')) > 0" class="rColor">{{scope.row.SixMonthRedound}}</span>
            <span v-else-if="parseFloat(scope.row.SixMonthRedound.replace('%','')) < 0" class="gColor">{{scope.row.SixMonthRedound}}</span>
            <span v-else>{{parseFloat(scope.row.SixMonthRedound.replace('%','')) =='--'?'--':scope.row.SixMonthRedound}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="OneYearRedound" label="近1年" width="92">
          <template slot-scope="scope">
            <span v-if="parseFloat(scope.row.OneYearRedound.replace('%','')) > 0" class="rColor">{{scope.row.OneYearRedound}}</span>
            <span v-else-if="parseFloat(scope.row.OneYearRedound.replace('%','')) < 0" class="gColor">{{scope.row.OneYearRedound}}</span>
            <span v-else>{{parseFloat(scope.row.OneYearRedound.replace('%','')) =='--'?'--':scope.row.OneYearRedound}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ThreeYearRedound" label="近3年" width="92">
          <template slot-scope="scope">
            <span v-if="parseFloat(scope.row.ThreeYearRedound.replace('%','')) > 0" class="rColor">{{scope.row.ThreeYearRedound}}</span>
            <span v-else-if="parseFloat(scope.row.ThreeYearRedound.replace('%','')) < 0" class="gColor">{{scope.row.ThreeYearRedound}}</span>
            <span v-else>{{parseFloat(scope.row.ThreeYearRedound.replace('%','')) =='--'?'--':scope.row.ThreeYearRedound}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ThisYearRedoundSort" label="今年以来" width="92">
          <template slot-scope="scope">
            <span v-if="parseFloat(scope.row.ThisYearRedoundSort.replace('%','')) > 0" class="rColor">{{scope.row.ThisYearRedoundSort}}</span>
            <span v-else-if="parseFloat(scope.row.ThisYearRedoundSort.replace('%','')) < 0" class="gColor">{{scope.row.ThisYearRedoundSort}}</span>
            <span v-else>{{parseFloat(scope.row.ThisYearRedoundSort.replace('%','')) =='--'?'--':scope.row.ThisYearRedoundSort}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <span v-if="scope.row.purchaseFlag" class="table-single-btn-normal" @click="purchaseClick(scope.row)">购买</span>
            <span v-else class="table-single-btn-forbid">购买</span>
            <span v-if="scope.row.business_flag.indexOf('1') != -1" class="table-single-btn-normal" @click="fixedClick(scope.row)">定投</span>
            <span v-else class="table-single-btn-forbid">定投</span>
            <span v-if="scope.row.diagnoseFlag" class="table-single-btn-normal" @click="diagnosisClick(scope.row)">诊断</span>
            <span v-else class="table-single-btn-forbid">诊断</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 页码 -->
      <el-pagination class="pagination-single" @current-change="handleCurrentChangeOne" :current-page.sync="purchase.PageNum" :page-size="purchase.Page" layout="prev, pager, next" :total="total" hide-on-single-page>
      </el-pagination>
    </div>
    <!-- 功能开发中 -->
    <el-dialog class="dialog-single-one" center :visible.sync="dialogVisable1" :show-close="false">
      <img src="../../../assets/images/development.png" alt="" style="width:120px;height:110px;">
      <span slot="footer" class="dialog-footer">
        <el-button type="normal1" @click="dialogVisable1 = false">确定</el-button>
      </span>
    </el-dialog>
    <!--风险提示-->
    <el-dialog class="dialog-single-three" :visible.sync="dialogVisable">
      <div class="dialog-single-three-p">风险提示</div>
      <p class="riskText">{{'经核实，您申请购买的产品风险等级为'+productRisklevel+'，您当前的风险等级为'+userRisk+'，适合您投资的产品最高风险等级为'+this.$commonJs.getcomLevel(this.$commonJs.getCookie('u_risk'))+'。根据适当性匹配原则，该产品高于您的风险承受能力。继续购买代表您已完全知悉该产品的风险并自愿承担后续决策风险。购买过程中销售机构未对您进行主动推介，特此确认。'}}</p>
      <div class="margin-t30">
        <el-button type="back" style="width:154px" @click="dialogVisable = false">取消购买</el-button>
        <el-button type="back" style="width:154px" @click="continueClick">继续购买</el-button>
      </div>
    </el-dialog>
    <!--恒宝宝基金提示-->
    <el-dialog class="dialog-single-three" :visible.sync="hbbDialogVisable">
      <div class="dialog-single-three-p">温馨提示</div>
      <p class="riskText">您当前购买的基金已经绑定了“恒宝宝”，请点击下方按钮继续购买此基金，购买后可到您的“恒宝宝”中查询交易以及收益详情。充值恒宝宝，稳享货币基金收益。</p>
      <div class="margin-t30">
        <el-button type="normal1" style="margin-left:82px;" @click="hbbContinueClick">{{riskContinue}}</el-button>
      </div>
    </el-dialog>
    <!-- 风险测评 -->
    <RiskTips v-if="riskShow" @func="getFunc"></RiskTips>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dialogVisable: false,
      hbbDialogVisable: false,
      userRisk: '',
      productRisklevel: '',
      fundRow: '',
      dialogVisable1: false,
      fundListsForm: {
        company: '',
        type: '',
        name: '',
        // buy: 2
      },
      input: '',
      fundListsTableData: [],
      purchase: {
        PageNum: 1,
        Page: 10,

      },
      total: 0,
      companyLists: [],
      loading: true,
      riskShow: false,
      hotFundLists: [],
      hotShow: true,
      riskContinue: '继续购买'
    }
  },
  mounted () {
    this.userRisk = this.$parameterConfig.p_risklevel[this.$commonJs.getCookie('u_risk')]
    this.companyLists = this.$store.state.fundCompany
    this.getFundLists()
    this.getHotFund()
  },
  methods: {
    // 风险测试
    getFunc (val) {
      window.sessionStorage.setItem('riskFlag', val)
    },
    returnClick () {
      if (this.$route.params.value == "couponDetail") {
        this.$router.push({
          name: 'couponDetail',
          params: {
            message: this.$route.params.message
          },
        })
      } else {
        this.$router.push({
          name: 'myAssets'
        })
      }
    },
    detailsClick () {
      this.$router.push({
        name: 'publicAssetsMessage',
        params: {
          value: 'publicPurchase'
        },
      })
    },
    // 当前页
    handleCurrentChangeOne (newPage) {
      this.purchase.PageNum = newPage
      this.loading = true
      this.getFundLists()
    },
    // 购买基金
    purchaseClick (row) {
      if (this.$commonJs.getCookie('u_risk') == "0") {// 是否进行过风险测评
        this.riskShow = true// 未进行风险测评
      } else {
        // 恒宝宝基金
        if (row.fundcode == "162206") {
          this.hbbDialogVisable = true
          return
        }
        this.fundRow = row
        if (!this.$commonJs.lm_checkFundLevel_jz(row.risklevel)) {//
          this.productRisklevel = this.$parameterConfig.p_fundlevel[row.risklevel]
          this.riskContinue = '继续购买'
          this.dialogVisable = true
        } else {
          this.$router.push({
            name: 'publicBuy',
            params: {
              fundMessage: row,
              pathName: 'publicPurchaseLists',
            }
          })
        }
      }

    },
    // 继续购买
    continueClick () {
      this.dialogVisable = false
      if (this.riskContinue == '继续购买') {
        this.$router.push({
          name: 'publicBuy',
          params: {
            fundMessage: this.fundRow,
            pathName: 'publicPurchaseLists',
          }
        })
      } else {
        this.$router.push({
          name: 'fixedBuyOpen',
          params: {
            message: this.fundRow,
            name: 'publicPurchaseLists',
          }
        })
      }

    },
    // 恒宝宝继续购买
    hbbContinueClick () {
      this.$router.push({ name: 'recharge' })
    },
    searchClick () {
      this.loading = true
      this.getFundLists()
    },
    // 定投
    fixedClick (row) {
      if (this.$commonJs.getCookie('u_risk') == "0") {
        this.riskShow = true
      } else {
        this.fundRow = row
        if (!this.$commonJs.lm_checkFundLevel_jz(row.risklevel)) {//
          this.productRisklevel = this.$parameterConfig.p_fundlevel[row.risklevel]
          this.riskContinue = '继续定投'
          this.dialogVisable = true
        } else {
          this.$router.push({
            name: 'fixedBuyOpen',
            params: {
              message: row,
              name: 'publicPurchaseLists',
            }
          })
        }
      }
    },
    diagnosisClick (row) {
      window.open('https://www.myfund.com/mutualSingleFundAnalysis/' + row.fundcode + '.html', '_blank')
    },
    // 基金列表
    getFundLists () {
      this.$http.post(this.$apiPath.fundList, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        qrytype: '',
        mktflag: '',
        tano: this.fundListsForm.company,//基金公司代号
        fundtype: this.fundListsForm.type,//基金类型
        inputvalue: this.fundListsForm.name,//基金代码
        requestid: this.purchase.PageNum,
      }).then(res => {
        this.loading = false
        if (res.status !== 200 && res.data.code !== '200') return
        const result = res.data.data
        result.fundList.forEach(item => {
          if (item.status == "0" || item.status == "1" || item.status == "7" || item.status == "8" || item.status == "b") {//购买
            item.purchaseFlag = true
          } else {
            item.purchaseFlag = false
          }
          if (item.fundtype == "0" || item.fundtype == "1" || item.fundtype == "3") {//诊断
            item.diagnoseFlag = true
          } else {
            item.diagnoseFlag = false
          }
          // 基金类型
          item.fundtype1 = this.$parameterConfig.p_fundtype[item.fundtype]
          // 风险等级
          if (item.risklevel == "01") {
            item.risklevel1 = "低";
          } else if (item.risklevel == "02") {
            item.risklevel1 = "中低";
          } else if (item.risklevel == "03") {
            item.risklevel1 = "中";
          } else if (item.risklevel == "04") {
            item.risklevel1 = "中高";
          } else if (item.risklevel == "05") {
            item.risklevel1 = "高";
          }
          // 基金状态
          item.status1 = this.$parameterConfig.p_fundstatus[item.status]

        });
        this.fundListsTableData = result.fundList
        this.total = result.totalNum
      }).catch(err => { })
    },
    // 
    getHotFund () {
      this.$http.get('https://www.myfund.com/webinterface/Bamboo.ashx?command=web_GMHotSearchFund', {}).then(res => {
        // console.log(res);
        if (res.status !== 200) return
        if (res.data.Result && res.data.fundlist.length > 0) {
          this.hotFundLists = res.data.fundlist.slice(0, 5)
        }

      }).catch(err => { })
    }
  }
}
</script>

<style lang="less" scoped>
// 浏览
.browse {
  position: relative;
  .browseTip {
    position: absolute;
    left: 0;
    top: 0;
    height: 31px;
    line-height: 31px;
  }
  .browseName {
    margin-left: 137px;
    display: inline-block;
    li {
      float: left;
      padding: 5px 18px;
      border: 1px solid @colorD4;
      margin-right: 10px;
      border-radius: 15px;
      cursor: pointer;
    }
  }
}
.riskText {
  font-size: 16px;
  margin-top: 20px;
}
</style>